import {
  LitElement,
  html,
  css,
  unsafeHTML,
  utils,
  paths,
  t,
} from '@hh/global.js'

class HHModal extends LitElement {
  static properties = {
    id: {},
    open: {
      reflect: true,
    },
    typeListener: { type: String },
  }

  constructor() {
    super()
    this.typeListener = 'openSearch'
    this.openSearch = this.openSearch.bind(this)
  }

  firstUpdated() {
    document.addEventListener(this.typeListener, this.openSearch)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener(this.typeListener, this.openSearch)
  }

  requestUpdate(name, oldValue) {
    if (name === 'open' && !!this[name]) {
      utils.pauseAllMedia()
    }

    return super.requestUpdate(name, oldValue)
  }

  openSearch() {
    if (this.classList.contains('header-search')) {
      this.open = true
      document
        .querySelector('.js-header-wrapper')
        ?.classList.remove('is-transparent')
      document.body.classList.add(
        'scroll-lock',
        'search-open',
        'block-scroll-search-open'
      )
      document.querySelector('html').classList.add('block-scroll-search-open')
      this.classList.add('active')
    }
  }

  close(event) {
    if (event.type === 'click' || event.code.toUpperCase() === 'ESCAPE') {
      document.body.classList.remove(
        'scroll-lock',
        'search-open',
        'block-scroll-search-open'
      )
      document
        .querySelector('html')
        .classList.remove('block-scroll-search-open')
      this.open = false
      this.classList.remove('active')

      return
    }
  }

  render() {
    return html`<div
      role="dialog"
      aria-modal="true"
      tabindex="-1"
    >
    <hh-focus-trap active="${this.open}" @keyup="${this.close}">
      <button
        @click="${this.close}"
        class="button"
        type="button"
        aria-label="${t('accessibility.close')}"
      >
        ${unsafeHTML(paths.close)}
      </button>
      <div
        class="content"
        role="document"
      >
          <slot></slot>
        </hh-focus-trap>
      </div>
    </div>`
  }

  static styles = css`
    :host {
      background-color: var(--hh-background);
      box-sizing: border-box;
      height: 100%;
      left: 0;
      opacity: 0;
      position: fixed;
      top: 0;
      transform: translateY(-150%);
      transition: transform var(--hh-duration-default);
      width: 100%;
      visibility: hidden;
      z-index: var(--hh-z-behind);
    }

    :host([size='flyout']) {
      max-width: var(--hh-max-width, 400px);
      height: auto;
      top: var(--hh-flyout-offset, 30px);
      right: var(--hh-flyout-offset, 30px);
      left: revert;
      border: 0.1rem solid var(--hh-border-color);
    }

    :host([open='true']) {
      opacity: 1;
      visibility: visible;
      z-index: calc(var(--hh-z-highest) + var(--hh-z-modal));
      transform: translateY(0);
    }

    .button svg {
      width: 12px;
      height: 12px;
    }

    .button svg,
    .button svg path {
      fill: var(--hh-color-honey-two);
    }

    .button {
      width: 4rem;
      position: absolute;
      top: -48px;
      right: 12px;
      display: flex;
      background-color: transparent;
      border: none;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 1.2rem;
      z-index: calc(var(--hh-z-base) + var(--hh-z-base));
    }

    @media screen and (min-width: 1440px) {
      .button {
        right: 4%;
        top: -6.5%;
      }
    }

    :host([size='flyout']) .button {
      position: absolute;
      top: var(--hh-close-top, 10px);
      right: var(--hh-close-right, 10px);
    }

    .content {
      display: flex;
      flex-direction: column;
      height: 100vh;
      overflow: hidden;
      width: 100%;
    }

    :host([size='flyout']) .content {
      height: auto;
    }
  `
}

customElements.define('hh-modal', HHModal)
